// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-panel-cis{
    width: 100%;
    height: 100%;
    position: relative;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
}
.content-cis{
    position: relative;
    justify-content: center;
    display: block;
    height: 98%;
    width: 94%;
border-radius:10px ;
box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);
border: 2px solid #003757;
  border-radius: 10px;
}
.cont-cis-search{
position: relative;
  height: 10%;
  width: 100%;
  /* background: rgba(195,195,195); */
  background: #003757;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px 5px 0px 0px;
}
.cont-search{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 25%;
}
.cont-search-space{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 55%;
}
.cont-search-buttons{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 20%;
}
.cont-cis-table{
    position: relative;
  height: 90%;
  width: 100%;
  /* background: rgba(195,195,195); */
  /* background: #003757; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-card-cis{
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}


  /****************************** tabla usuarios ******************************************/
  .cont-table-cis{
    width: 98%;
    height: 99%;
    /* border: 1px solid #56575746; */
    border-radius: 5px;
    display: block;
    position: relative;
  }
  .head-table-cis{
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 7%;
    background-color: rgb(138, 138, 138);
    /* background:#4392c0; */
    /* border-bottom: 1px solid #003757; */
     border-radius: 5px 5px 0px 0px;
     font-size: 11px;
  }
  .field-head-table-cis{
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: aliceblue;
    text-align: center;
  }
  .field-head-table-cis.field-nombre,.field-head-table-cis.field-small{
    border-right: 1px solid rgba(240, 248, 255, 0.473);
  }

  .field-small{
    width: 5%;
    border-right: 1px solid rgba(240, 248, 255, 0.473);
  }
  .field-larger{
    width: 12%;
    border-right: 1px solid rgba(240, 248, 255, 0.473);
  }

  .field-medium{
    width: 7%;
    border-right: 1px solid rgba(240, 248, 255, 0.473);
  }
  .body-table-cis{
    width: 100%;
    position: relative;
    display:block;
    justify-content: center;
    align-items: center;
    height: 90%;
    overflow: 'auto';
     
    
  }
  .row-table-cis{
    position: relative;
    display: flex;
    width: 100%;
    height: 40px;
    color:#003757;
  }
  .row-table-cis:nth-child(odd){
    background-color: #f8f9fa;
  }
  .row-table-cis:nth-child(even){
    background-color: #eeeeee;
  }
  .field-body-table-cis {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    text-align: center;
    word-wrap: anywhere;
  }
  .row-table-cis:hover{
    /* background-color: #00375771; */
    background-color: #004e7ba4;
    cursor: pointer;
    color: aliceblue !important;
  }
  /* .field-body-table-cis.field-nombre,.field-body-table-cis.field-acciones{
    border-right: 1px solid #0037573a;
  } */
/****************************** tabla usuarios Config ******************************************/
.cont-table-cis-config{
  width: 98%;
  height: 99%;
  /* border: 1px solid #56575746; */
  border-radius: 5px;
  display: block;
  position: relative;
}
.head-table-cis-config{
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10%;
  background-color: rgb(138, 138, 138);
  /* background:#4392c0; */
  /* border-bottom: 1px solid #003757; */
   border-radius: 5px 5px 0px 0px;
   font-size: 11px;
  
}
.field-head-table-cis-config{
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: aliceblue;
  text-align: center;
}
.field-head-table-cis-config.field-nombre,.field-head-table-cis-config.field-small{
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}

.field-small{
  width: 4%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}
.field-larger{
  width: 12%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}

.field-medium{
  width: 7%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}
.body-table-cis-config{
  width: 100%;
  position: relative;
  display:block;
  justify-content: center;
  align-items: center;
  height: 90%;
  overflow: 'auto';
   
  
}
.row-table-cis-config{
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  color:#003757;
}
.row-table-cis-config:nth-child(odd){
  background-color: #f8f9fa;
}
.row-table-cis-config:nth-child(even){
  background-color: #eeeeee;
}
.field-body-table-cis-config {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  text-align: center;
}
.row-table-cis-config:hover{
  background-color: #003757d3;
  cursor: pointer;
  color: aliceblue !important;
}
/* .field-body-table-cis-config.field-nombre,.field-body-table-cis-config.field-acciones{
  border-right: 1px solid #0037573a;
} */
  .cont-img-field-acciones{
    position: relative;
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img-field-acciones{
    position: relative;
    height: 70%;
  }

  .img-field-acciones:hover{
    transform: scale(1.1);
    transition: 0.3s;
  }
  .cont-load-user-list{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .cont-row-user-list{
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .field-body-table-cis {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
    /* font-size: small; */
    
  }
  .row-table-cis{
    position: relative;
    display: flex;
    width: 100%;
    height: 40px;
    color:#003757;
  }
  .row-table-cis:nth-child(odd){
    background-color: #f8f9fa;
  }
  .row-table-cis:nth-child(even){
    background-color: #eeeeee;
  }
  .field-body-table-cis {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* font-size: small; */
    
  }
  .row-table-cis:hover{
    background-color: #003757d3;
    cursor: pointer;
    color: aliceblue !important;
  }
 
  .form-msg-ok{
    color: #149209;
    position: absolute;
    left:0;
    /* top:10% */
    bottom: 0%;
    background-color: rgba(211, 255, 217, 0.64);
    width: 99%;
    text-align: center;
    border: 2px solid #149209;
    border-radius: 5px;
  }
  .no-results{
    position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: gray;
  }
  .pdf-download{
    position: absolute;
    width: 10%;
    left: 90%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img-down-pdf{
    height: 70%;
  }
  .img-down-pdf:hover{
    height: 80%;
    cursor: pointer;
  }

 .txtCisCancelada{
  font-weight: bold;
  color:red
 }
 .txtCisRechazada{
  font-weight: bold;
  color:red
 }  
 .txtCisCerrada{
  font-weight: bold;
  color:green
 }
 .txtCisIniciada{
  font-weight: bold;
  color:#d9bb18
 }
 .txtCisIniciado{
  font-weight: bold;
  color:#d9bb18
 }
 .txtCisNo{
  font-weight: bold;
  color:#000000
 }
 .txtCisPendiente{
  color:red
 }
 .Tooltip-coment{
  position: absolute;
  width: 130%;
  /* min-width: 80%; */
  height: 80%;
  background-color: rgba(240, 248, 255, 0.793);
  border: 1px solid grey;
  border-radius: 10px;
  /* top:-10px; */
  color:rgb(68, 68, 68);
  left: 110%;
  z-index: 5;
  display: none;
  justify-content: center;
  align-items: center;
 }

 .field-status:hover .Tooltip-coment{
  display: flex;
 }
 
 .NotifiCheckBox:hover{
  cursor: pointer;
 }`, "",{"version":3,"sources":["webpack://./src/components/cis-components/styles/PanelCis.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,UAAU;AACd,mBAAmB;AACnB,qFAAqF;AACrF,yBAAyB;EACvB,mBAAmB;AACrB;AACA;AACA,kBAAkB;EAChB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;AACA;IACI,kBAAkB;EACpB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;EAGE,yFAAyF;EACzF;IACE,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,oCAAoC;IACpC,wBAAwB;IACxB,sCAAsC;KACrC,8BAA8B;KAC9B,eAAe;EAClB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,kDAAkD;EACpD;;EAEA;IACE,SAAS;IACT,kDAAkD;EACpD;EACA;IACE,UAAU;IACV,kDAAkD;EACpD;;EAEA;IACE,SAAS;IACT,kDAAkD;EACpD;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;;;EAGlB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iCAAiC;IACjC,2BAA2B;IAC3B,eAAe;IACf,2BAA2B;EAC7B;EACA;;KAEG;AACL,gGAAgG;AAChG;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,wBAAwB;EACxB,sCAAsC;GACrC,8BAA8B;GAC9B,eAAe;;AAElB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kDAAkD;AACpD;AACA;EACE,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;;;AAGlB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;AAC7B;AACA;;GAEG;EACD;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,sBAAsB;;EAExB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;;EAExB;EACA;IACE,2BAA2B;IAC3B,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,2CAA2C;IAC3C,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,eAAe;EACjB;;CAED;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC;CACD;CACA;EACC,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,4CAA4C;EAC5C,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,eAAe;CAChB","sourcesContent":[".main-panel-cis{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    background-color: transparent;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.content-cis{\r\n    position: relative;\r\n    justify-content: center;\r\n    display: block;\r\n    height: 98%;\r\n    width: 94%;\r\nborder-radius:10px ;\r\nbox-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);\r\nborder: 2px solid #003757;\r\n  border-radius: 10px;\r\n}\r\n.cont-cis-search{\r\nposition: relative;\r\n  height: 10%;\r\n  width: 100%;\r\n  /* background: rgba(195,195,195); */\r\n  background: #003757;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 5px 5px 0px 0px;\r\n}\r\n.cont-search{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 25%;\r\n}\r\n.cont-search-space{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 55%;\r\n}\r\n.cont-search-buttons{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 20%;\r\n}\r\n.cont-cis-table{\r\n    position: relative;\r\n  height: 90%;\r\n  width: 100%;\r\n  /* background: rgba(195,195,195); */\r\n  /* background: #003757; */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.content-card-cis{\r\n    position: relative;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n\r\n  /****************************** tabla usuarios ******************************************/\r\n  .cont-table-cis{\r\n    width: 98%;\r\n    height: 99%;\r\n    /* border: 1px solid #56575746; */\r\n    border-radius: 5px;\r\n    display: block;\r\n    position: relative;\r\n  }\r\n  .head-table-cis{\r\n    width: 100%;\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 7%;\r\n    background-color: rgb(138, 138, 138);\r\n    /* background:#4392c0; */\r\n    /* border-bottom: 1px solid #003757; */\r\n     border-radius: 5px 5px 0px 0px;\r\n     font-size: 11px;\r\n  }\r\n  .field-head-table-cis{\r\n    height: 100%;\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: aliceblue;\r\n    text-align: center;\r\n  }\r\n  .field-head-table-cis.field-nombre,.field-head-table-cis.field-small{\r\n    border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n  }\r\n\r\n  .field-small{\r\n    width: 5%;\r\n    border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n  }\r\n  .field-larger{\r\n    width: 12%;\r\n    border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n  }\r\n\r\n  .field-medium{\r\n    width: 7%;\r\n    border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n  }\r\n  .body-table-cis{\r\n    width: 100%;\r\n    position: relative;\r\n    display:block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 90%;\r\n    overflow: 'auto';\r\n     \r\n    \r\n  }\r\n  .row-table-cis{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 40px;\r\n    color:#003757;\r\n  }\r\n  .row-table-cis:nth-child(odd){\r\n    background-color: #f8f9fa;\r\n  }\r\n  .row-table-cis:nth-child(even){\r\n    background-color: #eeeeee;\r\n  }\r\n  .field-body-table-cis {\r\n    position: relative;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 11px;\r\n    text-align: center;\r\n    word-wrap: anywhere;\r\n  }\r\n  .row-table-cis:hover{\r\n    /* background-color: #00375771; */\r\n    background-color: #004e7ba4;\r\n    cursor: pointer;\r\n    color: aliceblue !important;\r\n  }\r\n  /* .field-body-table-cis.field-nombre,.field-body-table-cis.field-acciones{\r\n    border-right: 1px solid #0037573a;\r\n  } */\r\n/****************************** tabla usuarios Config ******************************************/\r\n.cont-table-cis-config{\r\n  width: 98%;\r\n  height: 99%;\r\n  /* border: 1px solid #56575746; */\r\n  border-radius: 5px;\r\n  display: block;\r\n  position: relative;\r\n}\r\n.head-table-cis-config{\r\n  width: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 10%;\r\n  background-color: rgb(138, 138, 138);\r\n  /* background:#4392c0; */\r\n  /* border-bottom: 1px solid #003757; */\r\n   border-radius: 5px 5px 0px 0px;\r\n   font-size: 11px;\r\n  \r\n}\r\n.field-head-table-cis-config{\r\n  height: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: aliceblue;\r\n  text-align: center;\r\n}\r\n.field-head-table-cis-config.field-nombre,.field-head-table-cis-config.field-small{\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n\r\n.field-small{\r\n  width: 4%;\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n.field-larger{\r\n  width: 12%;\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n\r\n.field-medium{\r\n  width: 7%;\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n.body-table-cis-config{\r\n  width: 100%;\r\n  position: relative;\r\n  display:block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 90%;\r\n  overflow: 'auto';\r\n   \r\n  \r\n}\r\n.row-table-cis-config{\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 40px;\r\n  color:#003757;\r\n}\r\n.row-table-cis-config:nth-child(odd){\r\n  background-color: #f8f9fa;\r\n}\r\n.row-table-cis-config:nth-child(even){\r\n  background-color: #eeeeee;\r\n}\r\n.field-body-table-cis-config {\r\n  position: relative;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 11px;\r\n  text-align: center;\r\n}\r\n.row-table-cis-config:hover{\r\n  background-color: #003757d3;\r\n  cursor: pointer;\r\n  color: aliceblue !important;\r\n}\r\n/* .field-body-table-cis-config.field-nombre,.field-body-table-cis-config.field-acciones{\r\n  border-right: 1px solid #0037573a;\r\n} */\r\n  .cont-img-field-acciones{\r\n    position: relative;\r\n    width: 50%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .img-field-acciones{\r\n    position: relative;\r\n    height: 70%;\r\n  }\r\n\r\n  .img-field-acciones:hover{\r\n    transform: scale(1.1);\r\n    transition: 0.3s;\r\n  }\r\n  .cont-load-user-list{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  .cont-row-user-list{\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: auto;\r\n  }\r\n  .field-body-table-cis {\r\n    position: relative;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    overflow: auto;\r\n    /* font-size: small; */\r\n    \r\n  }\r\n  .row-table-cis{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 40px;\r\n    color:#003757;\r\n  }\r\n  .row-table-cis:nth-child(odd){\r\n    background-color: #f8f9fa;\r\n  }\r\n  .row-table-cis:nth-child(even){\r\n    background-color: #eeeeee;\r\n  }\r\n  .field-body-table-cis {\r\n    position: relative;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* font-size: small; */\r\n    \r\n  }\r\n  .row-table-cis:hover{\r\n    background-color: #003757d3;\r\n    cursor: pointer;\r\n    color: aliceblue !important;\r\n  }\r\n \r\n  .form-msg-ok{\r\n    color: #149209;\r\n    position: absolute;\r\n    left:0;\r\n    /* top:10% */\r\n    bottom: 0%;\r\n    background-color: rgba(211, 255, 217, 0.64);\r\n    width: 99%;\r\n    text-align: center;\r\n    border: 2px solid #149209;\r\n    border-radius: 5px;\r\n  }\r\n  .no-results{\r\n    position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: gray;\r\n  }\r\n  .pdf-download{\r\n    position: absolute;\r\n    width: 10%;\r\n    left: 90%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .img-down-pdf{\r\n    height: 70%;\r\n  }\r\n  .img-down-pdf:hover{\r\n    height: 80%;\r\n    cursor: pointer;\r\n  }\r\n\r\n .txtCisCancelada{\r\n  font-weight: bold;\r\n  color:red\r\n }\r\n .txtCisRechazada{\r\n  font-weight: bold;\r\n  color:red\r\n }  \r\n .txtCisCerrada{\r\n  font-weight: bold;\r\n  color:green\r\n }\r\n .txtCisIniciada{\r\n  font-weight: bold;\r\n  color:#d9bb18\r\n }\r\n .txtCisIniciado{\r\n  font-weight: bold;\r\n  color:#d9bb18\r\n }\r\n .txtCisNo{\r\n  font-weight: bold;\r\n  color:#000000\r\n }\r\n .txtCisPendiente{\r\n  color:red\r\n }\r\n .Tooltip-coment{\r\n  position: absolute;\r\n  width: 130%;\r\n  /* min-width: 80%; */\r\n  height: 80%;\r\n  background-color: rgba(240, 248, 255, 0.793);\r\n  border: 1px solid grey;\r\n  border-radius: 10px;\r\n  /* top:-10px; */\r\n  color:rgb(68, 68, 68);\r\n  left: 110%;\r\n  z-index: 5;\r\n  display: none;\r\n  justify-content: center;\r\n  align-items: center;\r\n }\r\n\r\n .field-status:hover .Tooltip-coment{\r\n  display: flex;\r\n }\r\n \r\n .NotifiCheckBox:hover{\r\n  cursor: pointer;\r\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
